(function () {
  'use strict';

  angular
    .module('app.lazyload')
    .constant('APP_REQUIRES', {
      // jQuery based and standalone scripts
      scripts: {
        'icons': [
          'vendor/font-awesome/css/font-awesome.min.css',
          'vendor/simple-line-icons/css/simple-line-icons.css'
        ],
        'date-time-picker': [
          'vendor/eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.min.css',
          'vendor/eonasdan-bootstrap-datetimepicker/build/js/bootstrap-datetimepicker.min.js',
          'vendor/angular-eonasdan-datetimepicker/dist/angular-eonasdan-datetimepicker.min.js'
        ],
        'fancybox': [
          'vendor/@fancyapps/fancybox/dist/jquery.fancybox.min.js',
          'vendor/@fancyapps/fancybox/dist/jquery.fancybox.min.css'
        ]
      },
      // Angular based script (use the right module name)
      modules: [
        {
          name: 'ngDialog',
          files: [
            'vendor/ng-dialog/js/ngDialog.min.js',
            'vendor/ng-dialog/css/ngDialog.min.css',
            'vendor/ng-dialog/css/ngDialog-theme-default.min.css'
          ]
        }, {
          name: 'localytics.directives',
          files: [
            'vendor/chosen-js/chosen.jquery.min.js',
            'vendor/chosen-js/chosen.min.css',
            'vendor/angular-chosen-localytics/dist/angular-chosen.js'
          ],
          serie: true
        }, {
          name: 'ui.sortable',
          files: [
            'vendor/jquery-ui/dist/jquery-ui.min.js',
            'vendor/angular-ui-sortable/dist/sortable.js'
          ],
          serie: true
        }, {
          name: 'infinite-scroll',
          files: [
            'vendor/ng-infinite-scroll/build/ng-infinite-scroll.min.js'
          ]
        }
      ]
    });
})();
